import React from 'react';

import Icons, { IconType } from './CustomIcon.config';

import * as Styles from './CustomIcon.styles';

export enum IconLabelPositionEnum {
  Start = 'start',
  End = 'end',
}

interface IconDefaultProps {
  label?: string;
  className?: string;
  wrapperClassName?: string;
  size?: number;
  dense?: boolean;
  labelPosition?: IconLabelPositionEnum | null;
  color?: string;
}

// Split interfaces, to make OR name OR src
export interface IconWithNameProps extends IconDefaultProps {
  name: IconType;
  src?: never;
}
export interface IconWithSrcProps extends IconDefaultProps {
  name?: never;
  src: string;
}

export type CustomIconProps = React.HTMLAttributes<HTMLSpanElement> &
  (IconWithNameProps | IconWithSrcProps);

const CustomIcon: React.FC<CustomIconProps> = ({
  name,
  src,
  label,
  className,
  wrapperClassName,
  size = 1,
  dense = false,
  labelPosition = IconLabelPositionEnum.Start,
  onClick,
  color,
  id,
}) => {
  const Icon = name != null ? Icons[name] : null;
  const iconSrc = src != null && src?.length > 0 ? src : null;
  const isWithLabel = Boolean(label != null && label?.length > 0);
  const shouldShowStartLabel =
    isWithLabel && labelPosition === IconLabelPositionEnum.Start;
  const shouldShowEndLabel =
    isWithLabel && labelPosition === IconLabelPositionEnum.End;

  return (
    <Styles.Icon
      onClick={onClick}
      fontSize={size}
      dense={dense}
      isWithLabel={isWithLabel}
      className={wrapperClassName}
      color={color}
    >
      {shouldShowStartLabel ? <Styles.Label>{label}</Styles.Label> : null}
      {iconSrc == null ? (
        // @ts-expect-error // TODO: fix types
        <Icon id={id} className={className} />
      ) : (
        <img id={id} className={className} alt={label} src={iconSrc} />
      )}
      {shouldShowEndLabel ? <Styles.Label>{label}</Styles.Label> : null}
    </Styles.Icon>
  );
};

export default CustomIcon;
